import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editRecommendationCategoryDialog from '../dialog.editRecommendationCategoryDialog';
import editRecommendationDialog from '../dialog.editRecommendationDialog';
import controller from './recommendation-category.controller';
import directive from './recommendation-category.directive';
import recommendation from '../recommendation';


export default angular.module('app.components.advisory.auditTrail.recommendationCategory', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  editRecommendationCategoryDialog,
  editRecommendationDialog,
  recommendation,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amRecommendationCategory', directive)
  .controller('RecommendationCategoryController', controller)
  .name;

console.log('app.components.advisory.auditTrail.recommendationCategory created');
